import React from 'react';

import { ClickEventComponentNames } from 'features/analytics';
import { logButtonClick } from 'features/navigation/utils/analytics';

import { BackArrow } from 'components/navigation/back-arrow';

import { ProductDetailBackArrowContainer } from './styled';
import { IProductDetailBackArrow } from './types';

export const ProductDetailBackArrow: React.FC<IProductDetailBackArrow> = ({
  onPress,
  eventAttributes = {},
  backNavigationLabel = '',
  color,
}) => {
  const handlePress = () => {
    logButtonClick({
      attributes: {
        ...eventAttributes,
        name: eventAttributes?.name ?? '',
        component: ClickEventComponentNames.PRODUCT_DETAIL_BACK_NAVIGATION,
      },
    });

    onPress();
  };

  return (
    <ProductDetailBackArrowContainer>
      <BackArrow onPress={handlePress} accessibilityLabel={backNavigationLabel} color={color} />
    </ProductDetailBackArrowContainer>
  );
};
